const SplashBg = require("./splash-bg.png");
const Request_Error = require("./request-error.png");
const Up_Arrow_Icon = require("./up-arrow-icon.png");
const Nafath_Verify = require("./nafath-verify.png");
const Link_Bank = require("./link-bank.png");
const Mask_Dashboard = require("./mask-dashboard.png");
const New_Bank = require("./new-bank.png");
const Eligible_For_Finance = require("./eligible-for-finance.png");
const Riyadh_Bank = require("./riyadh-bank.png");
const Maximum_Trial = require("./maximum-trial.png");
const Bank_Revenue = require("./bank-revenue.png");
const Splash_Logo = require("./splash-logo.png");
const SNBBank = require("./banks/SNB_bank.jpg");
const FileUpload = require("./file-upload.png");
const Bin = require("./bin.png");
const UploadIcon = require("./upload-icon.png");
const ApplicationSubmitSuccess = require("./application-submit-success.png");
const SnbFavicon = require("./banks-favicon/snb_favicon.png");
const SaudiAwwalBankFavicon = require("./banks-favicon/saudi_awwal_bank_favicon.png");
const SnbBank = require("./bank-logos/snb.png");
const SabBank = require("./bank-logos/sab.png");
const HourglassRepresenting = require("./hourglass-representing.png");
const BGFleetFinanceMin = require("./fleet-finance-bg-min.png");
const FleetFinanceCampaignCarsMin = require("./fleet-finance-campaign-cars-min.png");
const FleetFinanceDistributorBgMin = require("./fleet-finance-distributor-bg-min.png");
const TechnyClipboardWithChecklist = require("./techny-clipboard-with-checklist.png");

export {
  SplashBg,
  Request_Error,
  Up_Arrow_Icon,
  Nafath_Verify,
  Link_Bank,
  Mask_Dashboard,
  New_Bank,
  Eligible_For_Finance,
  Riyadh_Bank,
  Maximum_Trial,
  Bank_Revenue,
  Splash_Logo,
  SNBBank,
  FileUpload,
  Bin,
  UploadIcon,
  ApplicationSubmitSuccess,
  SnbFavicon,
  SaudiAwwalBankFavicon,
  SnbBank,
  SabBank,
  HourglassRepresenting,
  BGFleetFinanceMin,
  FleetFinanceCampaignCarsMin,
  FleetFinanceDistributorBgMin,
  TechnyClipboardWithChecklist,
};
